import React from "react";
import { CheckCircle, Circle, XCircle } from "lucide-react";

type PasswordMatchProps = {
  password: string;
  confirmPassword: string;
};

// Live feedback under a "Confirm Password" field. While the user is still
// typing a correct prefix it stays neutral, so they aren't shown an error
// before they've had a chance to finish.
const FleetrifyPasswordMatch: React.FC<PasswordMatchProps> = ({
  password,
  confirmPassword,
}) => {
  if (!confirmPassword) return null;

  const matches = confirmPassword === password;
  const stillTyping = !matches && password.startsWith(confirmPassword);

  const { Icon, iconClass, textClass, label } = matches
    ? { Icon: CheckCircle, iconClass: "text-green-500", textClass: "text-green-600", label: "Passwords match" }
    : stillTyping
      ? { Icon: Circle, iconClass: "text-gray-400", textClass: "text-gray-600", label: "Passwords must match" }
      // : { Icon: XCircle, iconClass: "text-red-500", textClass: "text-red-600", label: "This does not match the password you entered. Kindly confirm again." };
      : { Icon: XCircle, iconClass: "text-red-500", textClass: "text-red-600", label: "Password confirmation does not match kindly confirm again." };
  return (
    <div
      className="flex items-center gap-2 text-xs -mt-4 transition-colors duration-300"
      role="status"
      aria-live="polite"
    >
      <Icon className={`w-5 h-5 shrink-0 ${iconClass}`} aria-hidden="true" />
      <span className={textClass}>{label}</span>
    </div>
  );
};

export default FleetrifyPasswordMatch;
